// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/header/stylesheet/header.scss
 ** module id = 438
 ** module chunks = 1
 **/